import { SET_ABN_TESTS, TSetAbnTests } from '@r1-frontend/entities/stores/city/reducer';

export const setAbnVariants = (variants: string): TSetAbnTests => ({
    type: SET_ABN_TESTS,
    payload: {
        abnTests: {
            variants,
            isSended: false,
        },
    },
});
